import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Constants } from '../const/constants';

import { Alert, AlertType } from './alert';

@Injectable()
export class AlertService {
	private subject = new Subject<Alert>();
	private keepAfterRouteChange = false;
	private timer: any;

	constructor(private router: Router) {
		// clear alert messages on route change unless 'keepAfterRouteChange' flag is true
		router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterRouteChange) {
					// only keep for a single route change
					this.keepAfterRouteChange = false;
				} else {
					// clear alert messages
					this.clear();
				}
			}
		});
	}

	getAlert(): Observable<any> {
		return this.subject.asObservable();
	}

	success(message: string, keepAfterRouteChange = false) {
		this.alert(AlertType.Success, message, keepAfterRouteChange);
	}

	handleError(errorObj: any, keepAfterRouteChange = false) {
		if (errorObj.title == "NOTAUTHENTICATED") {
			localStorage.clear();
			this.router.navigateByUrl('/user/login');
		} else {
			let message = ""
			if (errorObj.error == undefined){
				message = Constants.ERROR_NO_INTERNET
			}
			else {
				message = errorObj.error.code
			}
			this.alert(AlertType.Error, message, keepAfterRouteChange);
		}
	}
	error(message: string, keepAfterRouteChange = false) {
		this.alert(AlertType.Error, message, keepAfterRouteChange);
	}

	info(message: string, keepAfterRouteChange = false) {
		this.alert(AlertType.Info, message, keepAfterRouteChange);
	}

	warn(message: string, keepAfterRouteChange = false) {
		this.alert(AlertType.Warning, message, keepAfterRouteChange);
	}

	alert(type: AlertType, message: string, keepAfterRouteChange = false) {
		this.keepAfterRouteChange = keepAfterRouteChange;
		this.subject.next(<Alert>{ type: type, message: message });
		if (type == AlertType.Success) {
			this.timerFunc()
		}
	}

	clear() {
		// clear alerts
		this.subject.next();
	}

	timerFunc() {
		this.timer = Observable.timer(5000)
		this.timer.subscribe(t => {
			this.clear()
		})
	}
}
